import { Route, Router } from '@solidjs/router';
import { render } from 'solid-js/web';
import App from './App';
import LoginPage from './components/Auth/LoginPage';
import AgentBuilder from './pages/AgentBuilder';
import ApiKeys from './pages/ApiKeys';
import ArtifactDetail from './pages/ArtifactDetail';
import Artifacts from './pages/Artifacts';
import AuthCallback from './pages/AuthCallback';
import Logout from './pages/Logout';
import BookmarkedProjects from './pages/BookmarkedProjects';
import Dashboard from './pages/Dashboard';
import Executions from './pages/Executions';
import ExecutionDetail from './pages/ExecutionDetail';
import ForkedProjects from './pages/ForkedProjects';
import Groups from './pages/Groups';
import Integrations from './pages/Integrations';
import JoinedProjects from './pages/JoinedProjects';
import Marketplace from './pages/Marketplace';
import ProjectBuilder from './pages/ProjectBuilder';
import ProjectDetail from './pages/ProjectDetail';
import Projects from './pages/Projects';
import RequirementBuilder from './pages/RequirementBuilder';
import ResetPassword from './pages/ResetPassword';
import Settings from './pages/Settings';
import SkillBuilder from './pages/SkillBuilder';
import Skills from './pages/Skills';
import Vault from './pages/Vault';
import Interactions from './pages/Interactions';
import WorkflowBuilder from './pages/WorkflowBuilder';
import AdminModels from './pages/AdminModels';
import './index.css';

// Handle redirect from 404.html (for SPA routing fallback)
const searchParams = new URLSearchParams(window.location.search);
const redirectPath = searchParams.get('redirect');
if (redirectPath) {
  window.history.replaceState(null, '', redirectPath);
}

// Portal runs at root (my.aigentswork.com)
render(
  () => (
    <Router root={App}>
      <Route path="/" component={Dashboard} />
      <Route path="/login" component={LoginPage} />
      <Route path="/logout" component={Logout} />
      <Route path="/auth/callback" component={AuthCallback} />
      <Route path="/reset-password" component={ResetPassword} />
      <Route path="/projects" component={Projects} />
      <Route path="/projects/new" component={ProjectBuilder} />
      <Route path="/projects/bookmarked" component={BookmarkedProjects} />
      <Route path="/projects/joined" component={JoinedProjects} />
      <Route path="/projects/forked" component={ForkedProjects} />
      <Route path="/projects/:id" component={ProjectDetail} />
      <Route path="/projects/:id/edit" component={ProjectBuilder} />
      <Route path="/projects/:id/requirements/new" component={RequirementBuilder} />
      <Route path="/projects/:id/requirements/:reqId" component={RequirementBuilder} />
      <Route path="/projects/:id/workflows/new" component={WorkflowBuilder} />
      <Route path="/projects/:id/workflows/:workflowId" component={WorkflowBuilder} />
      {/* Agent builder is accessed via project context */}
      <Route path="/projects/:projectId/agents/new" component={AgentBuilder} />
      <Route path="/projects/:projectId/agents/:id/edit" component={AgentBuilder} />
      <Route path="/skills" component={Skills} />
      <Route path="/skills/new" component={SkillBuilder} />
      <Route path="/skills/:id/edit" component={SkillBuilder} />
      <Route path="/artifacts" component={Artifacts} />
      <Route path="/artifacts/:id" component={ArtifactDetail} />
      <Route path="/executions" component={Executions} />
      <Route path="/executions/:id" component={ExecutionDetail} />
      <Route path="/interactions" component={Interactions} />
      <Route path="/marketplace" component={Marketplace} />
      <Route path="/integrations" component={Integrations} />
      <Route path="/vault" component={Vault} />
      <Route path="/api-keys" component={ApiKeys} />
      <Route path="/groups" component={Groups} />
      <Route path="/settings" component={Settings} />
      <Route path="/settings/models" component={AdminModels} />
    </Router>
  ),
  document.getElementById('root')!,
);
